import { useEffect } from "react";

// Constants
const GOOGLE_TAG_SCRIPT_ID = "google-tag-script";
const GOOGLE_TAG_URL =
  "https://www.googletagmanager.com/gtag/js?id=G-EX8SW60N92";
const GOOGLE_MEASUREMENT_ID = "G-EX8SW60N92";

const GoogleTag: React.FC = () => {
  useEffect(() => {
    // Prevent multiple script insertions
    if (document.getElementById(GOOGLE_TAG_SCRIPT_ID)) return;

    // Inject external gtag.js script
    const externalScript = document.createElement("script");
    externalScript.src = GOOGLE_TAG_URL;
    externalScript.async = true;
    externalScript.id = GOOGLE_TAG_SCRIPT_ID;
    document.head.appendChild(externalScript);

    // Inject inline configuration script
    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GOOGLE_MEASUREMENT_ID}');
    `;
    document.head.appendChild(inlineScript);
  }, []);

  // This component does not render any UI
  return null;
};

export default GoogleTag;
